import { Col, Form, Input, InputNumber, Radio, Row } from "antd";
import { fieldKhamBenh } from "pages/QuanLyKhamBenh/views/ThongTinKham/constantsTTK";
import { KOCO } from "pages/QuanLyKhamBenh/views/ThongTinKham/KhamSan/data";
import i18n, { languageKeys } from "../../../../i18n";
import styles from "./style.module.less";
const { Item } = Form;

export const TienSuSanKhoa = (
    {
        readOnlyInput,
        form
    }
) => {

    const onChange = async ({ value, type }) => {
        let newValue = value ?  value.toString() : '0';
        if (newValue?.toString()?.length === 1 &&
        Number(newValue) >= 0 && Number(newValue) <= 9 && type) {
            let valuePara = form.getFieldValue("PARA") || "";
            let arr = valuePara.split("");
            while (arr.length < 4) {
                arr.push('0');
            }

            // eslint-disable-next-line default-case
            switch (type) {
                case 'SINH':
                    arr[0] = newValue.toString();
                    break;
                case 'SOM':
                    arr[1] = newValue.toString();
                    break;
                case 'SAY':
                    arr[2] = newValue.toString();
                    break;
                case 'SONG':
                    arr[3] = newValue.toString();
                    break;
            }

            // Gán lại giá trị cho field PARA
            form.setFieldValue("PARA", arr.join(""));
        }
    };


    return (
        <div className={styles['tien-su-sk']} style={{ width: "100%", backgroundColor: "white", padding: "10px 10px" }}>
            <h2 className={styles['para']} style={{ display: "flex", justifyContent: "center", gap: 20 }}>PARA
                <Item disabled={readOnlyInput} name={fieldKhamBenh.PARA} rules={rulePara} initialValue={'0000'} >
                    <Input.TextArea disabled={true} autoSize style={{ width: '100px', borderRadius: 0 }} />
                </Item>
            </h2>
            <div className={styles['wrap-para']} style={{ display: "flex", width: "100%" }}>
                <div className={styles['col-pra']} style={{ width: "20%" }}>
                    <div className={styles['wrap-header']} >
                        <Header disabled={readOnlyInput} name={fieldKhamBenh.SL_SINH_DU_THANG} nameSunfix={i18n.t(languageKeys.sinh)?.toUpperCase()} onChange={() => onChange({ value: form.getFieldValue("SL_SINH_DU_THANG") || '0', type: 'SINH' })} />
                    </div>
                    <div className={styles['pra-content']} >
                        <InputLabel label={i18n.t(languageKeys.so_con_sinh_du_thang)} type="number" disabled={readOnlyInput}  onChange={() => onChange({ value: form.getFieldValue("SL_SINH_DU_THANG"), type: 'SINH' })}  name={fieldKhamBenh.SL_SINH_DU_THANG} />
                    </div>
                </div>
                <div className={styles['col-pra']} style={{ width: "20%" }}>
                    <div className={styles['wrap-header']} >
                        <Header disabled={readOnlyInput} name={fieldKhamBenh.SL_SINH_THIEU_THANG} nameSunfix={i18n.t(languageKeys.som)?.toUpperCase()}  onChange={() => onChange({ value: form.getFieldValue("SL_SINH_THIEU_THANG"), type: 'SOM' })}  />
                    </div>
                    <div className={styles['pra-content']}>
                        <InputLabel label={i18n.t(languageKeys.so_con_sinh_thieu_thang)} type="number" disabled={readOnlyInput}  onChange={() => onChange({ value: form.getFieldValue("SL_SINH_THIEU_THANG"), type: 'SOM' })}   name={fieldKhamBenh.SL_SINH_THIEU_THANG} />
                    </div>
                </div>
                <div className={styles['col-pra']} style={{ width: "40%" }}>
                    <div className={styles['wrap-header']} >
                        <Header disabled={readOnlyInput} name={fieldKhamBenh.SL_SAY} nameSunfix={i18n.t(languageKeys.say)?.toUpperCase()}   onChange={() => onChange({ value: form.getFieldValue("SL_SAY"), type: 'SAY' })}   />
                    </div>
                    <div style={{ display: "flex", width: "100%" }} className={styles['border-bottom']}>
                        <div style={{ width: "50%" }}>
                            <div className={`${styles['pra-content']} ${styles['border-right']}`}>
                                <InputLabel label={i18n.t(languageKeys.thai_luu_bao_nhieu_tuan)} disabled={readOnlyInput} name={fieldKhamBenh.SO_TUAN_THAI_LUU} onChange={() => onChange({ value: form.getFieldValue("SO_TUAN_THAI_LUU"), type: 'SO_TUAN_THAI_LUU' })} />
                                <InputLabel label={i18n.t(languageKeys.so_lan_thai_luu)} disabled={readOnlyInput} name={fieldKhamBenh.SO_LAN_THAI_LUU} onChange={(e) => {
                                    const valueSO_LAN_SAY_THAI = form.getFieldValue("SO_LAN_SAY_THAI") || 0;
                                    if (Number(e.target.value) >= 0 && Number(e.target.value) <= 9 && Number(valueSO_LAN_SAY_THAI) >= 0 && Number(valueSO_LAN_SAY_THAI) <= 9 && Number(valueSO_LAN_SAY_THAI) + Number(e.target.value) >= 0 && Number(valueSO_LAN_SAY_THAI) + Number(e.target.value) <= 9) {
                                        const value_SAY = Number(valueSO_LAN_SAY_THAI) + Number(e.target.value);
                                        form.setFieldValue("SL_SAY", value_SAY);
                                        onChange({ value: value_SAY, type: 'SAY' })

                                    }
                                }} />
                                <InputLabel label={i18n.t(languageKeys.nam_nao)} disabled={readOnlyInput} name={fieldKhamBenh.NAM_THAI_LUU} />
                            </div>
                        </div>
                        <div style={{ width: "50%" }}>
                            <div className={styles['pra-content']}>
                                <InputLabel label={i18n.t(languageKeys.say_thai_bao_nhieu_tuan)} disabled={readOnlyInput} name={fieldKhamBenh.SO_TUAN_SAY_THAI} 
                                 />
                                <InputLabel label={i18n.t(languageKeys.so_lan_say_thai)} disabled={readOnlyInput} name={fieldKhamBenh.SO_LAN_SAY_THAI}  onChange={(e) => {
                                    const valueSO_LAN_THAI_LUU = form.getFieldValue("SO_LAN_THAI_LUU") || 0;
                                    if (Number(e.target.value) >= 0 && Number(e.target.value) <= 9 && Number(valueSO_LAN_THAI_LUU) >= 0 && Number(valueSO_LAN_THAI_LUU) <= 9 && Number(valueSO_LAN_THAI_LUU) + Number(e.target.value) >= 0 && Number(valueSO_LAN_THAI_LUU) + Number(e.target.value) <= 9) {
                                        const value_SAY = Number(valueSO_LAN_THAI_LUU) + Number(e.target.value);
                                        form.setFieldValue("SL_SAY", value_SAY);
                                        onChange({ value: value_SAY, type: 'SAY' })

                                    }
                                }}/>
                                <InputLabel label={i18n.t(languageKeys.nam_nao)} disabled={readOnlyInput} name={fieldKhamBenh.NAM_SAY_THAI} />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", width: "100%" }} className={styles['border-bottom']}>
                        <div style={{ width: "50%" }}>
                            <div className={`${styles['pra-content']} ${styles['border-right']}`}>
                                <InputLabel label={i18n.t(languageKeys.chua_ngoai_tu_cung_may_lan)} disabled={readOnlyInput} name={fieldKhamBenh.SO_LAN_CHUA_NGOAI_TU_CUNG} />
                                <InputLabel label={i18n.t(languageKeys.ben_nao)} disabled={readOnlyInput} name={fieldKhamBenh.BEN_CHUA_NGOAI_TU_CUNG} />
                                <InputLabel label={i18n.t(languageKeys.nam_nao)} disabled={readOnlyInput} name={fieldKhamBenh.NAM_CHUA_NGOAI_TU_CUNG} />
                            </div>
                        </div>
                        <div style={{ width: "50%" }}>
                            <div className={styles['pra-content']}>
                                <InputLabel label={i18n.t(languageKeys.thai_sinh_hoa_may_lan)} disabled={readOnlyInput} name={fieldKhamBenh.SO_LAN_THAI_SINH_HOA} />
                                <InputLabel label={i18n.t(languageKeys.nam_nao)} disabled={readOnlyInput} name={fieldKhamBenh.NAM_THAI_SINH_HOA} />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", width: "100%" }}>
                        <div style={{ width: "50%" }}>
                            <div className={`${styles['pra-content']}`}>
                                <InputLabel label={i18n.t(languageKeys.chua_trung_may_lan)} disabled={readOnlyInput} name={fieldKhamBenh.SO_LAN_CHUA_TRUNG} />
                                <InputLabel label={i18n.t(languageKeys.nam_nao)} disabled={readOnlyInput} name={fieldKhamBenh.NAM_CHUA_TRUNG} />
                            </div>
                        </div>
                    </div>

                </div>
                <div className={styles['col-pra']} style={{ width: "20%" }}>
                    <div className={styles['wrap-header']} >
                        <Header disabled={readOnlyInput} name={fieldKhamBenh.SL_SONG} nameSunfix={i18n.t(languageKeys.song)?.toUpperCase()}  onChange={() => onChange({ value: form.getFieldValue("SL_SONG"), type: 'SONG' })}   />
                    </div>
                    <div className={styles['pra-content']}>
                        <InputLabel label={i18n.t(languageKeys.so_con_song)} type="number" disabled={readOnlyInput}   onChange={() => onChange({ value: form.getFieldValue("SL_SONG"), type: 'SONG' })} name={fieldKhamBenh.SL_SONG} />
                    </div>
                </div>
            </div>
            <div style={{marginTop: 12}}>
                <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.NOTE_PARA} label={`5. ${i18n.t(languageKeys.khac)}`} customClass={styles['customClass']} />
            </div>
            <h2 style={{ marginTop: 20, marginBottom: 20 }} className={styles['para']} >{i18n.t(languageKeys.chu_ky_kinh)?.toUpperCase()}</h2>
            <Row gutter={[20, 20]} >
                <Col span={12} >
                    <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.TUOI_CO_KINH_NGUYET} label={`1. ${i18n.t(languageKeys.thay_kinh_nguyet_bn_tuoi)}`} customClass={styles['customClass']} />
                </Col>
                <Col span={12} >
                    <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.CHU_KY_KINH} label={`2. ${i18n.t(languageKeys.chu_ky_kinh)}`} customClass={styles['customClass']} /></Col>
                <Col span={12} >
                    <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.CHU_KY_SO_NGAY_RA_MAU} label={`3. ${i18n.t(languageKeys.so_ngay_ra_mau)}`} customClass={styles['customClass']} /></Col>
                <Col span={12} >
                    <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.LUONG_KINH} label={`4.${i18n.t(languageKeys.quantity)}: ${i18n.t(languageKeys.nhieu_trung_binh_it)} ?`} customClass={styles['customClass']} /></Col>
                <Col span={24} >
                    <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.CHU_KY_NOTE} label={`5. ${i18n.t(languageKeys.khac)}`} customClass={styles['customClass']} /></Col>
            </Row>
            <h2 style={{ marginTop: 20, marginBottom: 20 }} className={styles['para']} >{i18n.t(languageKeys.roi_loan_kinh_nguyet)?.toUpperCase()}</h2>
            <Row gutter={[20, 20]} >
                <Col span={24} >
                    <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.ROI_LOAN_SO_NGAY_RA_MAU} label={`1. ${i18n.t(languageKeys.hien_tai_ra_mau_bn_ngay)}? ${i18n.t(languageKeys.quantity)}: ${i18n.t(languageKeys.nhieu_trung_binh_it)}`} customClass={styles['customClass']} />
                </Col>
                <Col span={24} >
                    <div style={{ display: "flex", width: "100%", alignItems: "center" }} >
                        <label style={{ marginRight: 20 }} >2. {i18n.t(languageKeys.co_dang_dung_bptt)} ?</label>
                        <Form.Item name={fieldKhamBenh.BIEN_PHAP_TRANH_THAI} disabled={readOnlyInput} style={{ marginBottom: 0 }} >
                            <Radio.Group disabled={readOnlyInput}>
                                {KOCO?.map(obj => <Radio value={obj.value}>{obj.label}</Radio>)}
                            </Radio.Group>
                        </Form.Item>
                    </div>
                    <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.DESC_BIEN_PHAP_TRANH_THAI} customClass={styles['customClass']} /></Col>
                <Col span={24} >
                    <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.ROI_LOAN_NOTE} label={`3 ${i18n.t(languageKeys.khac)}`} customClass={styles['customClass']} /></Col>

            </Row>
            <h2 className={styles['para']} style={{ display: "flex", justifyContent: "center", gap: 20 }}>
                {i18n.t(languageKeys.khac)}
            </h2>
            <InputLabel disabled={readOnlyInput} name={fieldKhamBenh.NOTE_TIEN_SU_SAN_KHOA} label={` ${i18n.t(languageKeys.khac)}`} customClass={styles['customClass']} />

        </div>
    )
}

export const Header = ({ name = '', nameSunfix = '', disabled, onChange, rules }) => {
    return <div className={styles['header']} >
        <Item disabled={disabled} name={name}
            rules={rules ? rules : ruleSoNguyen09}
        >
            <Input disabled={disabled} defaultValue={0} style={{ width: '50px', borderRadius: 0 }} controls={false} min={0} step={1} onChange={onChange} />
        </Item>
        <p className={styles['sunfix']} >{nameSunfix}</p>
    </div>
}

export const InputLabel = ({ name = '', label, type = 'text', customClass = '', disabled, onChange, children, ...props }) => {

    const renderInputByType = () => {
        switch (type) {
            case 'number':
                return <InputNumber disabled={disabled} defaultValue={0} style={{ width: '70px', borderRadius: 0 }} controls={false} min={0} step={1} onChange={onChange} />
            case 'text':
                return <Input.TextArea disabled={disabled} autoSize style={{ width: '70px', borderRadius: 0 }} onChange={onChange}  />
            default:
                break;
        }
    }
    return <div className={`${styles['InputLabel']} ${customClass}`} >
        {label ? <label>{label}</label> : ''}
        <Item disabled={disabled} name={name}  {...props}>
            {renderInputByType()}
        </Item>
    </div>
}

export const ruleSoNguyen09 = [{
    pattern: /^[0-9]$/,
    message: ""
},
{
    pattern: /^-?\d+$/,
    message: ""
}]

const rulePara = [
    {
        pattern: /^\d{4}$/,
        message: ""
    }
]